import Vue from "vue"
const svga = {
    inserted(el, binding) {
        // console.log("🚀 ~ binding", binding)
        // console.dir( el)
        el.setAttribute('src',binding.value.src) 
        el.style.height = binding.value.h+'px'
        el.style.width = binding.value.w+'px'
       el.style.cursor='pointer';
         Vue.prototype.$svga.autoload(el)
        
      
    }
}

export default svga


// WEBPACK FOOTER //
// ./src/common/directives/svga.js